import PropTypes from 'prop-types';
import React from 'react';

/**
 * VH Logo Component - Official Virtual Hardhat logo
 * Displays the orange hard hat with circuit board pattern
 */
export default function VHLogo({ showText = true, size = 'default', className = '', textColor = 'dark' }) {
  const sizeClasses = {
    small: {
      logo: 'h-16 w-16',
      text: 'text-lg ml-2',
    },
    default: {
      logo: 'h-20 w-20',
      text: 'text-xl ml-3',
    },
    large: {
      logo: 'h-28 w-28',
      text: 'text-2xl ml-4',
    },
  };

  const textColorClasses = {
    dark: 'text-neutral-900',
    light: 'text-white',
  };

  const currentSize = sizeClasses[size];

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/vh-logo.png" 
        alt="Virtual Hardhat Logo" 
        className={currentSize.logo}
        style={{ objectFit: 'contain' }}
      />
      {showText && (
        <span className={`${currentSize.text} font-bold ${textColorClasses[textColor]}`}>
          Virtual Hardhat
        </span>
      )}
    </div>
  );
}

VHLogo.propTypes = {
  showText: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'default', 'large']),
  className: PropTypes.string,
  textColor: PropTypes.oneOf(['dark', 'light']),
};
